export class GlobalSettingsContextModel {
	public compactComments?: boolean;
	public defaultMinutesInBreak?: number;
	public defaultGroupName = "Unlinked";
	constructor(mcm?: Partial<GlobalSettingsContextModel>) {
		Object.assign(this, mcm);
	}
}
